export interface PendingInventoryActivitySearchCriteria  {
  status?: string,
  eventType?: string,
  locationId?: string,
  errorCode?: string,
  bookingNumber?: string,
  equipmentNumber?: string,
  startDate?: string,
  endDate?: string,
}

/** Keys that make the report search all dates while filled (see `withDateRangeBypass`). */
export const SUPPLIER_PENDING_INVENTORY_ACTIVITY_DATE_BYPASS_KEYS: readonly (keyof PendingInventoryActivitySearchCriteria)[] = ['bookingNumber', 'equipmentNumber'];
